"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'ai.assist.attachKnowledge': 'Allega Conoscenza:',
    'ai.assist.knowledgeFound': 'Conoscenza rilevante trovata',
    'ai.assist.relevantKnowledgeFound': 'Conoscenza rilevante trovata dopo la conversazione',
    'ai.assist.attachmentIds': 'ID allegati',
};
